import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fak8czuqg9: FaireBrandEntity = {
  token: "b_fak8czuqg9",
  type: "brand",
  name: "Mandala Gems",
  avatarUrl:
    "https://cdn.faire.com/fastly/a775c6a8b36e5501424df88cbbbbbd9ae1d90867ce51d73def5ba47bba2917dd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/77f749071415c3e923a4cd65266c8d09b6d41cc38e90418e359c8292a41e88d4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a775c6a8b36e5501424df88cbbbbbd9ae1d90867ce51d73def5ba47bba2917dd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/77f749071415c3e923a4cd65266c8d09b6d41cc38e90418e359c8292a41e88d4.jpeg",
  location: "Asheville, NC, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 429,
  isTopShop: true,
  isInsider: true,
  description:
    "Mandala Gems is a single-mom–owned studio rooted in ethics, artistry, and care.\n\nWhat began as a deep love for the natural world has grown into a multifaceted brand offering ethically sourced crystals, mystical artwork created by me, and a curated line of natural beauty and fragrance products, all made in-house with intention.\n\nEach crystal is hand-selected for quality, integrity, and origin, working only with trusted sources that prioritize ethical mining and respectful labor practices. No mass sourcing, no mystery supply chains, just thoughtfully chosen pieces meant to be treasured.\n\nAlongside the minerals, you’ll find my original artwork: dreamlike, mythic, and inspired by fossils, botany, and the quiet magic of becoming. These designs flow into my natural fragrance and beauty offerings, which are small-batch, thoughtfully formulated, and crafted entirely in my studio.\n\nAt the heart of Mandala Gems is a belief in slowness, care, and meaning. Everything we create is designed to feel personal, grounded, and soulful, whether it’s a crystal for a collector, a scent for daily ritual, or art meant to live with someone for years.\n\nWhen you stock Mandala Gems, you’re supporting a woman-run business built on ethics, creativity, and resilience, and offering your customers objects that carry both beauty and intention. ✨",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.221Z",
    importedBy: "entity-db-cli",
  },
};
